/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FilterModelDTO,
  LockUserDTO,
  PasswordResetResultDTO,
  QueryColumnConfigDTO,
  UserActivityDTOQueryResultDTO,
  UserDTOQueryResultDTO,
  UserDetailDTO,
  UserManagementGetAllUsersListParams,
  UserManagementGetAllUsersParams,
  UserManagementGetUserActivityParams,
  UserManagementSearchUsersParams,
  UserSearchResultDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





/**
 * @summary Get all users across all organizations with pagination and filtering
 */
export const userManagementGetAllUsers = (
    params?: UserManagementGetAllUsersParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserDTOQueryResultDTO>(
      {url: `/api/site-admin/UserManagement`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getUserManagementGetAllUsersQueryKey = (params?: UserManagementGetAllUsersParams,) => {
    return [`/api/site-admin/UserManagement`, ...(params ? [params]: [])] as const;
    }

    
export const getUserManagementGetAllUsersQueryOptions = <TData = Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError = ErrorType<unknown>>(params?: UserManagementGetAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserManagementGetAllUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userManagementGetAllUsers>>> = ({ signal }) => userManagementGetAllUsers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserManagementGetAllUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userManagementGetAllUsers>>>
export type UserManagementGetAllUsersQueryError = ErrorType<unknown>


export function useUserManagementGetAllUsers<TData = Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  UserManagementGetAllUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userManagementGetAllUsers>>,
          TError,
          Awaited<ReturnType<typeof userManagementGetAllUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserManagementGetAllUsers<TData = Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError = ErrorType<unknown>>(
 params?: UserManagementGetAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userManagementGetAllUsers>>,
          TError,
          Awaited<ReturnType<typeof userManagementGetAllUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserManagementGetAllUsers<TData = Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError = ErrorType<unknown>>(
 params?: UserManagementGetAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all users across all organizations with pagination and filtering
 */

export function useUserManagementGetAllUsers<TData = Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError = ErrorType<unknown>>(
 params?: UserManagementGetAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetAllUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserManagementGetAllUsersQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get all users across all organizations with advanced filtering
 */
export const userManagementGetAllUsersList = (
    filterModelDTO: FilterModelDTO[],
    params?: UserManagementGetAllUsersListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserDTOQueryResultDTO>(
      {url: `/api/site-admin/UserManagement/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getUserManagementGetAllUsersListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userManagementGetAllUsersList>>, TError,{data: FilterModelDTO[];params?: UserManagementGetAllUsersListParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userManagementGetAllUsersList>>, TError,{data: FilterModelDTO[];params?: UserManagementGetAllUsersListParams}, TContext> => {
    
const mutationKey = ['userManagementGetAllUsersList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userManagementGetAllUsersList>>, {data: FilterModelDTO[];params?: UserManagementGetAllUsersListParams}> = (props) => {
          const {data,params} = props ?? {};

          return  userManagementGetAllUsersList(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserManagementGetAllUsersListMutationResult = NonNullable<Awaited<ReturnType<typeof userManagementGetAllUsersList>>>
    export type UserManagementGetAllUsersListMutationBody = FilterModelDTO[]
    export type UserManagementGetAllUsersListMutationError = ErrorType<unknown>

    /**
 * @summary Get all users across all organizations with advanced filtering
 */
export const useUserManagementGetAllUsersList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userManagementGetAllUsersList>>, TError,{data: FilterModelDTO[];params?: UserManagementGetAllUsersListParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userManagementGetAllUsersList>>,
        TError,
        {data: FilterModelDTO[];params?: UserManagementGetAllUsersListParams},
        TContext
      > => {

      const mutationOptions = getUserManagementGetAllUsersListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get user filter configuration
 */
export const userManagementGetUserFilterConfig = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<QueryColumnConfigDTO[]>(
      {url: `/api/site-admin/UserManagement/filter-config`, method: 'GET', signal
    },
      );
    }
  

export const getUserManagementGetUserFilterConfigQueryKey = () => {
    return [`/api/site-admin/UserManagement/filter-config`] as const;
    }

    
export const getUserManagementGetUserFilterConfigQueryOptions = <TData = Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserManagementGetUserFilterConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>> = ({ signal }) => userManagementGetUserFilterConfig(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserManagementGetUserFilterConfigQueryResult = NonNullable<Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>>
export type UserManagementGetUserFilterConfigQueryError = ErrorType<unknown>


export function useUserManagementGetUserFilterConfig<TData = Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserManagementGetUserFilterConfig<TData = Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserManagementGetUserFilterConfig<TData = Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user filter configuration
 */

export function useUserManagementGetUserFilterConfig<TData = Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserManagementGetUserFilterConfigQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Search users by email, name, or username
 */
export const userManagementSearchUsers = (
    params?: UserManagementSearchUsersParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserSearchResultDTO[]>(
      {url: `/api/site-admin/UserManagement/search`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getUserManagementSearchUsersQueryKey = (params?: UserManagementSearchUsersParams,) => {
    return [`/api/site-admin/UserManagement/search`, ...(params ? [params]: [])] as const;
    }

    
export const getUserManagementSearchUsersQueryOptions = <TData = Awaited<ReturnType<typeof userManagementSearchUsers>>, TError = ErrorType<unknown>>(params?: UserManagementSearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementSearchUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserManagementSearchUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userManagementSearchUsers>>> = ({ signal }) => userManagementSearchUsers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userManagementSearchUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserManagementSearchUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userManagementSearchUsers>>>
export type UserManagementSearchUsersQueryError = ErrorType<unknown>


export function useUserManagementSearchUsers<TData = Awaited<ReturnType<typeof userManagementSearchUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  UserManagementSearchUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementSearchUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userManagementSearchUsers>>,
          TError,
          Awaited<ReturnType<typeof userManagementSearchUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserManagementSearchUsers<TData = Awaited<ReturnType<typeof userManagementSearchUsers>>, TError = ErrorType<unknown>>(
 params?: UserManagementSearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementSearchUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userManagementSearchUsers>>,
          TError,
          Awaited<ReturnType<typeof userManagementSearchUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserManagementSearchUsers<TData = Awaited<ReturnType<typeof userManagementSearchUsers>>, TError = ErrorType<unknown>>(
 params?: UserManagementSearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementSearchUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search users by email, name, or username
 */

export function useUserManagementSearchUsers<TData = Awaited<ReturnType<typeof userManagementSearchUsers>>, TError = ErrorType<unknown>>(
 params?: UserManagementSearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementSearchUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserManagementSearchUsersQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get detailed information about a specific user
 */
export const userManagementGetUserDetail = (
    userId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserDetailDTO>(
      {url: `/api/site-admin/UserManagement/${userId}`, method: 'GET', signal
    },
      );
    }
  

export const getUserManagementGetUserDetailQueryKey = (userId: number,) => {
    return [`/api/site-admin/UserManagement/${userId}`] as const;
    }

    
export const getUserManagementGetUserDetailQueryOptions = <TData = Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError = ErrorType<unknown>>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserManagementGetUserDetailQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userManagementGetUserDetail>>> = ({ signal }) => userManagementGetUserDetail(userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserManagementGetUserDetailQueryResult = NonNullable<Awaited<ReturnType<typeof userManagementGetUserDetail>>>
export type UserManagementGetUserDetailQueryError = ErrorType<unknown>


export function useUserManagementGetUserDetail<TData = Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError = ErrorType<unknown>>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userManagementGetUserDetail>>,
          TError,
          Awaited<ReturnType<typeof userManagementGetUserDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserManagementGetUserDetail<TData = Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError = ErrorType<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userManagementGetUserDetail>>,
          TError,
          Awaited<ReturnType<typeof userManagementGetUserDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserManagementGetUserDetail<TData = Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError = ErrorType<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get detailed information about a specific user
 */

export function useUserManagementGetUserDetail<TData = Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError = ErrorType<unknown>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserManagementGetUserDetailQueryOptions(userId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Reset a user's password (generates a new temporary password)
 */
export const userManagementResetUserPassword = (
    userId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PasswordResetResultDTO>(
      {url: `/api/site-admin/UserManagement/${userId}/reset-password`, method: 'POST', signal
    },
      );
    }
  


export const getUserManagementResetUserPasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userManagementResetUserPassword>>, TError,{userId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userManagementResetUserPassword>>, TError,{userId: number}, TContext> => {
    
const mutationKey = ['userManagementResetUserPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userManagementResetUserPassword>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  userManagementResetUserPassword(userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserManagementResetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof userManagementResetUserPassword>>>
    
    export type UserManagementResetUserPasswordMutationError = ErrorType<unknown>

    /**
 * @summary Reset a user's password (generates a new temporary password)
 */
export const useUserManagementResetUserPassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userManagementResetUserPassword>>, TError,{userId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userManagementResetUserPassword>>,
        TError,
        {userId: number},
        TContext
      > => {

      const mutationOptions = getUserManagementResetUserPasswordMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Lock or unlock a user account
 */
export const userManagementLockUser = (
    userId: number,
    lockUserDTO: LockUserDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/site-admin/UserManagement/${userId}/lock`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: lockUserDTO, signal
    },
      );
    }
  


export const getUserManagementLockUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userManagementLockUser>>, TError,{userId: number;data: LockUserDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userManagementLockUser>>, TError,{userId: number;data: LockUserDTO}, TContext> => {
    
const mutationKey = ['userManagementLockUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userManagementLockUser>>, {userId: number;data: LockUserDTO}> = (props) => {
          const {userId,data} = props ?? {};

          return  userManagementLockUser(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserManagementLockUserMutationResult = NonNullable<Awaited<ReturnType<typeof userManagementLockUser>>>
    export type UserManagementLockUserMutationBody = LockUserDTO
    export type UserManagementLockUserMutationError = ErrorType<unknown>

    /**
 * @summary Lock or unlock a user account
 */
export const useUserManagementLockUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userManagementLockUser>>, TError,{userId: number;data: LockUserDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userManagementLockUser>>,
        TError,
        {userId: number;data: LockUserDTO},
        TContext
      > => {

      const mutationOptions = getUserManagementLockUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Confirm a user's email address
 */
export const userManagementConfirmUserEmail = (
    userId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/site-admin/UserManagement/${userId}/confirm-email`, method: 'POST', signal
    },
      );
    }
  


export const getUserManagementConfirmUserEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userManagementConfirmUserEmail>>, TError,{userId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userManagementConfirmUserEmail>>, TError,{userId: number}, TContext> => {
    
const mutationKey = ['userManagementConfirmUserEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userManagementConfirmUserEmail>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  userManagementConfirmUserEmail(userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserManagementConfirmUserEmailMutationResult = NonNullable<Awaited<ReturnType<typeof userManagementConfirmUserEmail>>>
    
    export type UserManagementConfirmUserEmailMutationError = ErrorType<unknown>

    /**
 * @summary Confirm a user's email address
 */
export const useUserManagementConfirmUserEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userManagementConfirmUserEmail>>, TError,{userId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userManagementConfirmUserEmail>>,
        TError,
        {userId: number},
        TContext
      > => {

      const mutationOptions = getUserManagementConfirmUserEmailMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get user activity/audit logs
 */
export const userManagementGetUserActivity = (
    userId: number,
    params?: UserManagementGetUserActivityParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserActivityDTOQueryResultDTO>(
      {url: `/api/site-admin/UserManagement/${userId}/activity`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getUserManagementGetUserActivityQueryKey = (userId: number,
    params?: UserManagementGetUserActivityParams,) => {
    return [`/api/site-admin/UserManagement/${userId}/activity`, ...(params ? [params]: [])] as const;
    }

    
export const getUserManagementGetUserActivityQueryOptions = <TData = Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError = ErrorType<unknown>>(userId: number,
    params?: UserManagementGetUserActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserManagementGetUserActivityQueryKey(userId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userManagementGetUserActivity>>> = ({ signal }) => userManagementGetUserActivity(userId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserManagementGetUserActivityQueryResult = NonNullable<Awaited<ReturnType<typeof userManagementGetUserActivity>>>
export type UserManagementGetUserActivityQueryError = ErrorType<unknown>


export function useUserManagementGetUserActivity<TData = Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError = ErrorType<unknown>>(
 userId: number,
    params: undefined |  UserManagementGetUserActivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userManagementGetUserActivity>>,
          TError,
          Awaited<ReturnType<typeof userManagementGetUserActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserManagementGetUserActivity<TData = Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError = ErrorType<unknown>>(
 userId: number,
    params?: UserManagementGetUserActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userManagementGetUserActivity>>,
          TError,
          Awaited<ReturnType<typeof userManagementGetUserActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserManagementGetUserActivity<TData = Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError = ErrorType<unknown>>(
 userId: number,
    params?: UserManagementGetUserActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user activity/audit logs
 */

export function useUserManagementGetUserActivity<TData = Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError = ErrorType<unknown>>(
 userId: number,
    params?: UserManagementGetUserActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userManagementGetUserActivity>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserManagementGetUserActivityQueryOptions(userId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



